import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {TheCrypt} from "../../TheCrypt";
import {ScatterCounter} from "../../view/ScatterCounter";

export class TheCryptAvalancheIdlePresentation implements FlowStatePresentation {

    constructor() {
    }

    start(flowStateController:FlowStateController):void {
        SlotGame.apiPlugin.betHandler.zeroBet();
        if (TheCrypt.model.isRestore) {
            ScatterCounter.onRestore();
        }
        flowStateController.finish();
    }
}